// ============================================================================
// visszaVedelem.js — a böngésző "vissza" mozdulata ne dobja ki a felhasználót az alkalmazásból (2026-10-16, tagi jelzés).
//
// A MIÉRT: az iPhone Safariban a képernyő szélétől indított húzás a böngésző "vissza" mozdulata. Az alkalmazás egyetlen oldal
// (nincs előzménybejegyzése), ezért a "vissza" az ELŐZŐ oldalra - a bejelentkezésre - vitt, jelentkezéskor pedig elveszett a munka.
// Ezt CSS-sel nem lehet kikapcsolni; az egyetlen megbízható megoldás egy őrszem-bejegyzés az előzményben: a "vissza" azt
// használja el, mi pedig azonnal újat teszünk a helyére, és közben az alkalmazáson BELÜL lépünk vissza (téma -> témalista).
//
// Csak érintőképernyős eszközön és csak bejelentkezett képernyőn él: számítógépen a böngésző vissza gombja a megszokott módon
// működik, a bejelentkezési folyamatot (átirányítás, felugró ablak) pedig nem zavarja.
// ============================================================================

const OR_SZEM = { lineage0: "vissza-vedelem" };

/**
 * @param {Window} win
 * @param {{aktiv: () => boolean, vissza: () => void, erintes?: boolean}} opciok
 *   aktiv:   igaz, ha a védelem most érvényes (bejelentkezett képernyő);
 *   vissza:  az alkalmazáson belüli "egy lépés vissza" (pl. témából a témalistába); semmit sem csinál, ha nincs hová;
 *   erintes: felülbírálja az érintőképernyő-felismerést (teszthez).
 * @returns {() => void} a védelem leállítása
 */
export function visszaVedelem(win, { aktiv, vissza, erintes }) {
  const erintoEszkoz = typeof erintes === "boolean"
    ? erintes
    : Boolean(win.matchMedia && win.matchMedia("(pointer: coarse)").matches);
  if (!erintoEszkoz || !win.history || typeof win.history.pushState !== "function") return () => {};

  const orszemetTesz = () => {
    try {
      win.history.pushState(OR_SZEM, "", win.location.href);
    } catch (e) {
      // Az előzmény módosítása korlátozott lehet (pl. beágyazott nézet): ilyenkor nincs védelem, de nincs hiba sem.
    }
  };
  orszemetTesz();

  const kezelo = () => {
    if (!aktiv()) return;
    // A "vissza" elfogyasztotta az őrszemet: az alkalmazáson belüli lépés, majd új őrszem a helyére.
    try {
      vissza();
    } finally {
      orszemetTesz();
    }
  };
  win.addEventListener("popstate", kezelo);
  return () => win.removeEventListener("popstate", kezelo);
}
